import React, { Token, useEffect, useState, Fragment } from 'react'

import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { getEmployerOrCarrierRecipients } from '../../services/dataService';


const RecipientSelection = ({ handleUserSelected, returnUrl }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [lookupType, setLookupType] = useState("Carrier");

  const handleSearch = async (query) => {
    setIsLoading(true);

    const items = await getEmployerOrCarrierRecipients(query, lookupType);

    const options = items.map((i) => ({
      id: i.id,
      name: i.name,
    }));

    setOptions(options);
    setIsLoading(false);
  };

  const handleChange = (value) => {
      setIsLoading(false);
    handleUserSelected(value, returnUrl, lookupType);
  };

  let focusControl = null;
  useEffect(() => {
    focusControl && focusControl.focus();
  })

  const buildPlaceholderText = ()=>{
    switch (lookupType) {
      case "Carrier":
        return "Search by carrier name"
      case "Employer":
          return "Search by employer name"
    }
  }


  return (
    <section class="portal-user-type-selection-section">

        <div >
          <input type="radio" name="userType" value="Carrier" id="Carrier" onClick={() => setLookupType("Carrier")} checked={lookupType === "Carrier"} />
          <label className="nav-login-label" for="Carrier">Carrier</label>
          <input type="radio" name="userType" value="Employer" id="Employer" onClick={() => setLookupType("Employer")} checked={lookupType === "Employer"} />
          <label className="nav-login-label" for="Employer" >Employer</label>

        </div>        
        <AsyncTypeahead
          id="search"
          ref={(ctl) => { focusControl = ctl; }}
          isLoading={isLoading}
          labelKey={(option) => `${option.name}`}
          minLength={3}
          onSearch={handleSearch}
          onChange={(value) => handleChange(value[0])}
          useCache={false}
          options={options}
          placeholder = {buildPlaceholderText()}
          renderToken={(option, index) => (
            <Token
              key={index} />
          )}
  
        />  
    </section>
  );

  
};



export default RecipientSelection;